module.exports = __webpack_public_path__ + "img/HogHaven.c7e6b3ff.png";